import { PageHero } from "../components/PageHero";
import { PackageCard } from "../components/PackageCard";
import { Reveal } from "../components/motion";
import { EnquiryDialog } from "../components/EnquiryDialog";
import { PACKAGES, IMAGES } from "../data/site";
import { Check } from "lucide-react";

const CONFIG = {
  honeymoon: {
    eyebrow: "Honeymoon Packages",
    title: ["Romance, written", "in backwaters."],
    subtitle: "Private houseboats, candlelit dinners and misty hill mornings — honeymoon journeys crafted for two.",
    image: IMAGES.backwaterSunset,
    presetType: "Honeymoon",
    intro: "Begin your forever with the most romantic corners of Kerala. We arrange private houseboat stays in Alleppey, cosy hill resorts in Munnar and thoughtful little surprises along the way.",
    points: ["Private candlelit houseboat dinner", "Flower-decorated honeymoon rooms", "Sunset backwater cruise for two", "Couple spa & Ayurveda sessions", "Dedicated honeymoon coordinator"],
  },
  "family-tours": {
    eyebrow: "Family Tours",
    title: ["Holidays the whole", "family will treasure."],
    subtitle: "Gentle itineraries, comfortable hotels and safe private cabs — designed for kids, parents and grandparents alike.",
    image: IMAGES.family,
    presetType: "Family",
    intro: "Travelling with little ones or senior parents? We plan relaxed, well-paced Kerala tours with family-friendly hotels, clean private cabs and plenty of time to soak it all in.",
    points: ["Spacious family & connecting rooms", "Gentle, senior-friendly itineraries", "Verified, courteous drivers", "Kid-friendly sightseeing & wildlife", "24x7 on-trip WhatsApp support"],
  },
  "group-tours": {
    eyebrow: "Group Tours",
    title: ["Big groups,", "zero chaos."],
    subtitle: "From corporate offsites to NRI family reunions — seamless logistics for groups of every size.",
    image: IMAGES.munnarValley,
    presetType: "Group",
    intro: "Whether it's a 40-person corporate offsite or a large extended family reunion, we handle transport, stays and activities so everyone travels together, effortlessly.",
    points: ["Coach & multi-cab coordination", "Group hotel & houseboat blocks", "Custom team activities & bonfires", "Single point of contact throughout", "Transparent per-head pricing"],
  },
};

export default function CategoryPage({ type }) {
  const c = CONFIG[type];
  return (
    <div data-testid={`category-${type}`}>
      <PageHero eyebrow={c.eyebrow} title={c.title} subtitle={c.subtitle} image={c.image} />
      <section className="max-w-[1200px] mx-auto px-5 lg:px-10 py-24">
        <div className="grid lg:grid-cols-2 gap-16 items-center mb-24">
          <Reveal>
            <p className="eyebrow text-gold mb-4">{c.eyebrow}</p>
            <h2 className="font-serif text-3xl lg:text-5xl font-light text-emerald leading-tight">{c.subtitle}</h2>
            <p className="text-ink/60 mt-6 leading-relaxed">{c.intro}</p>
            <div className="mt-8">
              <EnquiryDialog title={`${c.eyebrow} Enquiry`} presetType={c.presetType} trigger={
                <button className="bg-emerald text-cream px-8 py-4 text-xs uppercase tracking-[0.2em] font-semibold hover:bg-gold transition-colors" data-testid="category-enquire-btn">Plan My {c.presetType} Trip</button>
              } />
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="border border-emerald/15 p-8 lg:p-10 bg-white">
              <p className="eyebrow text-gold mb-6">What's Special</p>
              <ul className="space-y-4">
                {c.points.map((p) => <li key={p} className="flex gap-3 text-ink/75"><Check className="w-5 h-5 text-emerald shrink-0" /> {p}</li>)}
              </ul>
            </div>
          </Reveal>
        </div>

        <Reveal><p className="eyebrow text-gold mb-4">Suggested Itineraries</p>
          <h2 className="font-serif text-3xl lg:text-5xl font-light text-emerald mb-12">Popular picks for {c.presetType.toLowerCase()} travellers.</h2></Reveal>
        <div className="grid md:grid-cols-3 gap-8">
          {PACKAGES.map((p, i) => <Reveal key={p.slug} delay={i * 0.1}><PackageCard pkg={p} /></Reveal>)}
        </div>
      </section>
    </div>
  );
}
